import { getProgramsLoaded } from './programSelectors';
import { getShowProgramSelection } from './programListSelectors';
import { programStepPostConditions } from './programStepSelectors';



const programStepConfig = {
    component: () => import('./ProgramStep'),
    flow: 'buy',
    isReady: state => (
        getProgramsLoaded(state)
    ),
    canLoad: (state, ownProps) => {
        const { submitPath } = ownProps;
        return { isAllowedOrPath: getShowProgramSelection(state) || submitPath };
    },
    postConditions: programStepPostConditions
};

export default programStepConfig;
